import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from '../../../_shared/components/Icon';

import {
  Header,
  StyledYear,
  StyledMake,
  StyledModel,
  StyledTrim,
  FuelEconomyContainer,
  FuelType,
  FuelContainer,
  FuelAmount,
  FuelUnit,
  OmpPumpIcon
} from './Styles';

const VehicleHeader = ({ tradeDetails, mileage, isOmp }) => {
  const [hasMileage, setHasMileage] = useState(false);

  useEffect(() => {
    setHasMileage(
      mileage &&
        mileage?.unit &&
        (mileage?.city?.high || mileage?.city?.low) &&
        (mileage?.hwy?.high || mileage?.hwy?.low)
    );
  }, [mileage]);

  return (
    <Header>
      <StyledYear testId="retailVdp-year">{tradeDetails?.year}</StyledYear>
      <StyledMake data-testid="retailVdp-make" className="notranslate">
        {tradeDetails?.make}
      </StyledMake>
      <StyledModel data-testid="retailVdp-model" className="notranslate">
        {tradeDetails?.model}
      </StyledModel>
      <StyledTrim data-testid="retailVdp-trim">{tradeDetails?.trim}</StyledTrim>

      {!!hasMileage && Object.keys(mileage).length > 0 && (
        <FuelEconomyContainer>
          {!isOmp ? <Icon icon="pump" /> : <OmpPumpIcon icon="pump" />}
          <FuelType>
            <FuelContainer>
              <FuelAmount>
                {mileage?.city?.high || mileage?.city?.low}
              </FuelAmount>
              <FuelUnit>{mileage?.unit}</FuelUnit>
            </FuelContainer>
            <FormattedMessage id="retail.city" />
          </FuelType>
          <FuelType>
            <FuelContainer>
              <FuelAmount>{mileage?.hwy?.high || mileage?.hwy?.low}</FuelAmount>
              <FuelUnit>{mileage?.unit}</FuelUnit>
            </FuelContainer>
            <FormattedMessage id="retail.highway" />
          </FuelType>
        </FuelEconomyContainer>
      )}
    </Header>
  );
};

export default VehicleHeader;
